module.exports = __webpack_public_path__ + "sprstatic/img/logo@3x.5bb5dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo@3x.png
// module id = vGtg
// module chunks = 2